export default __webpack_public_path__ + "static/media/boating_in_naples.8b35e049.webp";